import { render, staticRenderFns } from "./GoogleDriveShortcut.vue?vue&type=template&id=befb9c8e&scoped=true&"
import script from "./GoogleDriveShortcut.vue?vue&type=script&lang=js&"
export * from "./GoogleDriveShortcut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befb9c8e",
  null
  
)

export default component.exports